<div class="PolicyDashboard">
    <div class="Loading" *ngIf="isShowLoading==true">
        <img id="" src="assets/img/762.gif" />
        <label class="loadertext">{{'Please Wait,Processing..'|translate }}</label>
    </div>

    <div class="container-fluid">

        <div class="row">

            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">

                <div class="col-md-12 proposals">

                    <div class="panel panel-default panel-table">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col col-xs-6">
                                    <h3 class="panel-title">{{'Renewal Policy'|translate }}</h3>
                                </div>
                            </div>
                        </div>

                        <div class="panel-body">
                            <form #comprenewalpolicyform="ngForm">
                                <div class="PaymentForm">


                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 arabicfieldarrange">
                                            <label>{{'PolicyNo' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                            <input type="text" class="form-control" [disabled]="true" name="txtPolicyNo"
                                                id="txtPolicyNo" [(ngModel)]="objBindInfoRes.PolicyNo">
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 arabicfieldarrange">
                                            <label>{{'Name' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                            <input type="text" class="form-control" [disabled]="true" name="txtName"
                                                id="txtName" [(ngModel)]="objBindInfoRes.InsuredName">
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 arabicfieldarrange">
                                            <label>{{'Iqama/ID No' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                            <input type="text" class="form-control" [disabled]="true" name="txtIqama"
                                                id="txtIqama" [(ngModel)]="objBindInfoRes.Insured_IdNo">
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 arabicfieldarrange">
                                            <label>{{'Sequence No' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                            <input type="text" class="form-control"
                                                [disabled]="objBindInfoRes.VehicleDefType=='2'"
                                                (keypress)="ValidateSpecialChar($event)" numbersOnly maxlength="9"
                                                minlength="6" name="txtSeq" #txtSeq id="txtSeq"
                                                [(ngModel)]="objBindInfoRes.SequenceNo">
                                          
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="renewObj.PrdCode=='5520'">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 arabicfieldarrange">
                                            <label>{{'Deductible Type' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                            <select [(ngModel)]="objBindInfoRes.DeductableType" required selectRequired
                                                class="form-control" name="txtDeduc" id="txtDeduc" #txtDeduc="ngModel">
                                                <option value="">--{{ 'Select Deductable'| translate}}--</option>
                                                <option *ngFor="let deduc of objBindInfoRes.deductableList"
                                                    [value]="deduc.DeductableCode">{{deduc.DeductableDescEn}}</option>
                                            </select>
                                            <span *ngIf="(txtDeduc.invalid && txtDeduc.dirty)"
                                                class="text-danger valid">
                                                <div *ngIf="txtDeduc.errors?.required">
                                                    {{ 'Deductable is required'| translate}}
                                                </div>
                                                <div *ngIf="txtDeduc.errors?.selectRequired">
                                                    {{ 'Deductable is required'| translate}}
                                                </div>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="renewObj.PrdCode=='5520'">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 arabicfieldarrange">
                                            <label>{{'Repair Type' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                            <select [(ngModel)]="objBindInfoRes.RepairType" class="form-control"
                                                selectRequired name="txtRepair" id="txtRepair" required
                                                #txtRepair="ngModel">
                                                <option value="">--{{ 'Select Repair Type' | translate}}--</option>
                                                <option *ngFor="let repair of objBindInfoRes.repairList"
                                                    [value]="repair.AgencyCode">
                                                    {{ Lng=="en"?repair.AgencyDescEn: repair.AgencyDescAr }}</option>
                                            </select>
                                            <span *ngIf="txtRepair.invalid && txtRepair.dirty"
                                                class="text-danger valid">
                                                <div *ngIf="txtRepair.errors.required">
                                                    {{'Repair Type is required'| translate}}
                                                </div>
                                                <div *ngIf="txtRepair.errors?.selectRequired">
                                                    {{ 'Repair Type is required'| translate}}
                                                </div>

                                            </span>
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="renewObj.PrdCode=='5520'">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 arabicfieldarrange">
                                            <label>{{'Vehicle Value' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">

                                            <input type="text" class="form-control" name="txtSum" autocomplete="off"
                                                id="txtSum" [(ngModel)]="objBindInfoRes.SumInsured" numbersOnly required
                                                #txtSum="ngModel" maxlength="6"
                                                [customMin]="objBindInfoRes.MinSumInsured"
                                                [customMax]="objBindInfoRes.MaxSumInsured">

                                            <span *ngIf="txtSum.invalid && txtSum.dirty" class="text-danger valid">
                                                <div *ngIf="txtSum.errors.required">
                                                    {{ 'SumInsured is required'| translate}}<br />
                                                    {{ 'Sum insured must be between' | translate }}
                                                    {{objBindInfoRes.MinSumInsured}} - {{objBindInfoRes.MaxSumInsured}}
                                                </div>
                                                <div *ngIf="txtSum.errors?.customMin">
                                                    {{ 'SumInsured must be greater than'| translate}}
                                                    {{ objBindInfoRes.MinSumInsured }}
                                                </div>
                                                <div *ngIf="txtSum.errors?.customMax">
                                                    {{ 'SumInsured must be less than'| translate}}
                                                    {{ objBindInfoRes.MaxSumInsured}}
                                                </div>
                                            </span>
                                        </div>
                                    </div>



                                    <div class="row buttons">

                                        <div class="PayButton col-sm-3 col-md-4">
                                            <button class="btn btn-primary btn-block" name="btnProceed" id="btnProceed"
                                                type="submit"
                                                [disabled]="comprenewalpolicyform.form.invalid || (renewObj.PrdCode=='5520' && objBindInfoRes.DeductableType=='0') || objBindInfoRes.SequenceNo==''"
                                                (click)="proceedToRenew(comprenewalpolicyform.valid)">{{'Renew Policy' | translate }}</button>
                                        </div>
                                        <div class="PayButton col-sm-3 col-md-4">
                                            <button class="btn btn-primary btn-block" name="btnCancel" id="btnCancel"
                                                (click)="Cancel()">{{'Cancel' | translate }}</button>
                                        </div>

                                        <div class="PayButton col-sm-3 col-md-4">
                                            <button class="btn btn-primary btnadddriver" data-toggle="modal"
                                                data-target="#AdditionalDrivers">{{'Add Drivers'| translate }}</button>
                                        </div>

                                        <div class="PayButton col-sm-3 col-md-4">
                                            <button class="btn btn-primary btnadddriver" data-toggle="modal"
                                                data-target="#DriverList">{{'View Drivers'| translate }}</button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>


                    </div>

                </div>
            </div>

            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>


        </div>
    </div>


    <!--View Driver List Start -->

    <div class="modal fade" style="z-index: 1000 !important" id="DriverList" data-backdrop="static" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" #closeBtn>&times;</button>
                    <h4 class="modal-title logins">{{'Aditional Drivers' | translate }}</h4>
                 </div>
                 <div class="modal-body">

                    <div  *ngFor="let drv of objBindInfoRes.DriverList;let i=index;">
                
                        <div class="card" style="width:100%;">
                       
                            <div class="tab-content">
                                <div role="tabpanel" class="tab-pane active PolicyInfo">
                                    <label>
                                        <span class="lbltext">{{ 'Is Main Driver'| translate }}:</span>
                                        <span>
                                            {{drv.isMainDriverEn}}</span>
                                    </label>
                                    <label>
                                        <span class="lbltext">{{'Licence No'| translate }}:</span>
                                        <span>
                                            {{drv.DriverLicenseNo}}</span>
                                    </label>
                                    <label>
                                        <span class="lbltext">{{'DOB'| translate }}:</span>
                                        <span>
                                            {{drv.DriverDOB}}</span>
                                    </label>
                                    <label>
                                        <span class="lbltext">{{'Driver Name'| translate }}:</span>
                                        <span>
                                            {{Lng=="ar" ? drv.DriverNameAr:drv.DriverNameEn}}</span>
                                    </label>
                                    <label>
                                        <span class="lbltext">{{'Driver Gender'| translate }}:</span>
                                        <span>
                                            {{drv.Drivergender=="1"?"MALE":"FEMALE"}}</span>
                                    </label>
                                    <label>
                                        <span class="lbltext"> {{'Driver License Type'| translate }}:</span>
                                        <span>
                                            {{Lng=="en"? drv.DriverLicenseTypeEn:drv.DriverLicenseTypeAr}}</span>
                                    </label>
                                    <label>
                                        <span class="lbltext">{{'Driver Nationality'| translate }}:</span>
                                        <span>
                                            {{Lng=="en"? drv.DriverNationalityEn:drv.DriverNationalityAr}}
                                        </span>
                                    </label>
                                    <label>
                                        <span class="lbltext">{{'Licence expiry Date'| translate }}:</span>
                                        <span>{{drv.DriverLic_ExpiryDate}}</span>
                                    </label>
                                    <label>
                                        <span class="lbltext">{{'Marital Status'| translate }}:</span>
                                        <span>{{Lng=="en"? drv.DriverMaritalStatusEn:drv.DriverMaritalStatusAr}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                  
                </div>
                 </div>
            </div>
        </div>  
    </div>
    <!-- View Driver List End -->



    <!-- Add Driver Start -->
    <!-- <div class="modal fade" style="z-index: 1000 !important" id="AdditionalDrivers" data-backdrop="static"
    role="dialog">
    <div class="modal-dialog modal-lg">
       <div class="modal-content">
          <div class="modal-header">
             <button type="button" class="close" data-dismiss="modal" #closeBtn>&times;</button>
             <h4 class="modal-title logins">{{'Aditional Drivers' | translate }}</h4>
          </div>
          <div class="modal-body">
             <div class="DriverSearch">
                <div class="panel panel-primary">
                   <div class="panel-heading">
                      <span>{{'Driver Search' | translate }}</span>
                   </div>
                   <div class="panel-body">
                      <form #ds="ngForm">
                         <div class="Field">
                            <div class="row">
                               <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                  <label class="lbltext">{{ 'Driver Id'| translate }}</label>
                                  <input type="text" class="form-control" required numbersOnly
                                     placeholder="Driver id" id="txtIqamaNo" name="txtIqamaNo" maxlength="10"
                                     [(ngModel)]="DriverId" pattern="^[12][0-9]{9}$" #txtIqamaNo="ngModel"
                                     (ngModelChange)="SetDOBType(DriverId)" autocomplete="off" />
                                  <span
                                     *ngIf="txtIqamaNo.invalid && (txtIqamaNo.dirty || isSearchSubmitted || txtIqamaNo.touched)"
                                     class="text-danger DriverValid">
                                     <div *ngIf="txtIqamaNo.errors?.required">
                                        {{'Driver ID is required'| translate }}
                                     </div>
                                     <div *ngIf="txtIqamaNo.errors?.pattern">
                                        {{'Driver ID must start with 1 or 2'| translate }}
                                     </div>
                                  </span>
                               </div>
                               <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                  <div class="DOBField">
                                     <div class="col-lg-12 col-md-12 ">
                                        <div class="col-lg-12 col-md-12 col-xs-12 DateFieldHeading">
                                           <label class="lbltext"
                                              *ngIf="isGregorian==true">{{'Date Of Birth'| translate }}</label>
                                           <label class="lbltext"
                                              *ngIf="isGregorian==false">{{'Date of Birth Hijri'| translate }}</label>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6">
                                           <input type="text" required class="form-control" id="txtDOBMM"
                                              name="txtDOBMM" placeholder="MM" [(ngModel)]="DriverMM"
                                              #txtDOBMM="ngModel" maxlength="2" minlength="2" numbersOnly
                                              [CustomMonthDirective] autocomplete="off" />
                                           <span
                                              *ngIf="txtDOBMM.invalid && (txtDOBMM.dirty || isSearchSubmitted || txtDOBMM.touched)"
                                              class="text-danger DriverValid">
                                              <div *ngIf="txtDOBMM.errors?.required">
                                                 {{'MM is required'| translate }}
                                              </div>
                                              <div *ngIf="txtDOBMM.errors?.maxlength">
                                                 {{'MM must be 2 digits'| translate }}
                                              </div>
                                              <div *ngIf="txtDOBMM.errors?.minlength">
                                                 {{'MM must be 2 digits'| translate }}
                                              </div>
                                              <div *ngIf="txtDOBMM.errors?.CustomMonthDirective">
                                                 {{'Invalid Month'| translate }}
                                              </div>
                                           </span>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6">
                                           <input type="text" required class="form-control" id="txtDOBYY"
                                              name="txtDOBYY" placeholder="YYYY" [(ngModel)]="DriverYY"
                                              #txtDOBYY="ngModel" maxlength="4" minlength="4" numbersOnly
                                              YearCustomValidation={{DriverId}} autocomplete="off" />
                                           <span
                                              *ngIf="txtDOBYY.invalid && (txtDOBYY.dirty || isSearchSubmitted || txtDOBYY.touched)"
                                              class="text-danger DriverValid">
                                              <div *ngIf="txtDOBYY.errors?.required">
                                                 {{'YYYY is required'| translate }}
                                              </div>
                                              <div *ngIf="txtDOBYY.errors?.maxlength">
                                                 {{'YY must be 4 digits'| translate }}
                                              </div>
                                              <div *ngIf="txtDOBYY.errors?.minlength">
                                                 {{'YY must be 4 digits'| translate }}
                                              </div>
                                              <div *ngIf="txtDOBYY.errors?.YearCustomValidation">
                                                 {{'Invalid Year'| translate }}
                                              </div>
                                           </span>
                                        </div>
                                     </div>
                                  </div>
                               </div>
                               <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                  <button class="btn btns btn-primary" id="btnSearch" name="btnSearch"
                                     (click)="DriverSearch(ds.valid)"
                                     style="margin-top:20px!important;float:left;">{{'Search'| translate }}</button>
                               </div>
                            </div>
                         </div>
                      </form>
                   </div>
                  
                </div>
                <div class="DriverForm">
                   <div class="panel panel-primary">
                      <div class="panel-heading">
                         <span>{{'Driver Info' | translate }}</span>
                      </div>
                      <div class="panel-body">
                         <form #driverfrm="ngForm">
                            <div class="Field">
                               <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Main Driver'| translate }}</label>
                                     <select class="form-control" id="txtMainDriver" selectRequired
                                        name="txtMainDriver" [(ngModel)]="diverObj.Ismaindriver"
                                        #txtMainDriver="ngModel">
                                        <option value="0">--{{'isMainDriver'| translate }}--</option>
                                        <option value="1">{{'Yes'| translate }}</option>
                                        <option value="2">{{'No'| translate }}</option>
                                     </select>
                                     <span
                                        *ngIf="txtMainDriver.invalid && (txtMainDriver.dirty || isDriverSubmitted || txtMainDriver.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtMainDriver.errors?.selectRequired">
                                           {{'Main Driver is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Driver Name(Arabic)'| translate }}</label>
                                     <input type="text" class="form-control" required
                                        placeholder="{{'Driver Name(Arabic)' | translate }}'"
                                        id="txtDriverNameAr" name="txtDriverNameAr"
                                        [(ngModel)]="diverObj.DriverNameAr" #txtDriverNameAr="ngModel" />
                                     <span
                                        *ngIf="txtDriverNameAr.invalid && (txtDriverNameAr.dirty || isDriverSubmitted || txtDriverNameAr.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtDriverNameAr.errors?.required">
                                           {{'Driver Name Arabic is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Driver Name(English)'| translate }}</label>
                                     <input type="text" class="form-control" required
                                        placeholder="{{'Driver Name(English)' | translate }}'"
                                        id="txtDriverNameEn" name="txtDriverNameEn"
                                        [(ngModel)]="diverObj.DriverNameEn" pattern="^[\x00-\x7F]+$"
                                        #txtDriverNameEn="ngModel" />
                                     <span
                                        *ngIf="txtDriverNameEn.invalid && (txtDriverNameEn.dirty || isDriverSubmitted || txtDriverNameEn.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtDriverNameEn.errors?.required">
                                           {{'Driver Name English is required'| translate }}
                                        </div>
                                        <div *ngIf="txtDriverNameEn.errors?.pattern">
                                           {{'Driver Name must be in english'| translate }}
                                        </div>
                                     </span>
                                  </div>
                               </div>
                            </div>
                            <div class="Field">
                               <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Nationality'| translate }}</label>
                                     <select class="form-control" id="txtNat" name="txtNat" selectRequired
                                        [(ngModel)]="diverObj.DriverNationality" #txtNat="ngModel">
                                        <option value="0">--{{'Select Nationality'| translate }}--
                                        </option>
                                        <option *ngFor="let n of bindObj.NationalityMasterList"
                                           [value]="n.NationalityDesc">
                                           {{ Lng=="en"?n.NationalityDescEn:n.NationalityDescAr}}
                                        </option>
                                     </select>
                                     <span
                                        *ngIf="txtNat.invalid && (txtNat.dirty || isDriverSubmitted || txtNat.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtNat.errors?.selectRequired">
                                           {{'Nationality is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Marital Status'| translate }}</label>
                                     <select class="form-control" selectRequired name="txtMStatus"
                                        id="txtMStatus" [(ngModel)]="diverObj.DriverMaritalStatus"
                                        #txtMStatus="ngModel"
                                        [disabled]="objmdlDriverInfoRes.DriverMaritalStatusExists">
                                        <option value="0">--{{'Select  MaritalStatus'| translate }}--
                                        </option>
                                        <option *ngFor="let m of bindObj.MarStatusList"
                                           [value]="m.MarstatusCode">
                                           {{Lng=="en"?m.MarstatusDesc_En:m.MarstatusDesc_Ar}}</option>
                                     </select>
                                     <span
                                        *ngIf="txtMStatus.invalid && (txtMStatus.dirty || isDriverSubmitted || txtMStatus.touched)"
                                        class="text-danger valid">
                                        <div
                                           *ngIf="txtMStatus.errors?.selectRequired                                                                                                                       ">
                                           {{'Marrital Status is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'License Type'| translate }}</label>
                                     <select class="form-control" required name="txtlicType" id="txtlicType"
                                        [(ngModel)]="diverObj.DriverLicenseType" #txtlicType="ngModel"
                                        [disabled]="true">
                                        <option value="">--{{'Select LicenceType'| translate }}--
                                        </option>
                                        <option *ngFor="let l of bindObj.LicenceTypeList"
                                           [value]="l.LicTypecode">{{l.LicType_DescEn}}</option>
                                     </select>
                                     <span
                                        *ngIf="txtlicType.invalid && (txtlicType.dirty || isDriverSubmitted || txtlicType.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtlicType.errors?.required">
                                           {{'Marrital Status is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                               </div>
                            </div>
                            <div class="Field">
                               <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                   
                                     <label class="lbltext">{{'License Expiry Date'| translate }}</label>
                                     <input type="text" class="form-control" required
                                        id="txtDriverLicExpDate" name="txtDriverLicExpDate"
                                        [(ngModel)]="diverObj.DriverLic_ExpiryDate"
                                        #txtDriverLicExpDate="ngModel" HijriPicker autocomplete="off" />
                                     <span
                                        *ngIf="txtDriverLicExpDate.invalid && (txtDriverLicExpDate.dirty || isDriverSubmitted || txtDriverLicExpDate.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtDriverLicExpDate.errors?.required">
                                           {{'Driver License Expiry Date is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Driver Gender'| translate }}</label>
                                     <select id="txtDriverGender" selectRequired name="txtDriverGender"
                                        class="form-control" [(ngModel)]="diverObj.Drivergender"
                                        #txtDriverGender="ngModel"
                                        [disabled]="this.objmdlDriverInfoRes.Gender!=null">
                                        <option [value]="0">{{'Select Driver Gender'| translate }}</option>
                                        <option *ngFor="let gen of bindObj.GenderList"
                                           [value]="gen.gendercode">
                                           {{ Lng=="en"? gen.genderdesc_En : gen.GenderDesc_Ar }}</option>
                                     </select>
                                     <span
                                        *ngIf="txtDriverGender.invalid && (txtDriverGender.dirty || isDriverSubmitted || txtDriverGender.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtDriverGender.errors?.selectRequired">
                                           {{'Driver Gender is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Driver Education'| translate }}</label>
                                     <select id="txtDriverEducation" name="txtDriverEducation"
                                        class="form-control" selectRequired #txtDriverEducation="ngModel"
                                        [(ngModel)]="diverObj.DriverEducation">
                                        <option [value]="0">{{'Select Driver Education'| translate }}
                                        </option>
                                        <option *ngFor="let eduObj of bindObj.eduList"
                                           [value]="eduObj.EducationCode">
                                           {{Lng=="en"?eduObj.EducationDesc_En:eduObj.EducationDesc_Ar}}
                                        </option>
                                     </select>
                                     <span
                                        *ngIf="txtDriverEducation.invalid && (txtDriverEducation.dirty || isDriverSubmitted || txtDriverEducation.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtDriverEducation.errors.selectRequired">
                                           {{ 'Driver Education is required'| translate}}
                                        </div>
                                     </span>
                                  </div>
                               </div>
                            </div>
                            <div class="Field">
                               <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label
                                        class="lbltext">{{'No Of Years Saudi Licence Held'| translate }}</label>
                                     <select id="txtSaudiHeld" name="txtSaudiHeld" class="form-control"
                                        #txtSaudiHeld="ngModel" CustomNumberDirective
                                        [(ngModel)]="diverObj.SaudiLicenceHeld">
                                        <option [value]="-1">{{'Select'| translate }}</option>
                                        <option *ngFor="let year of bindObj.NumYearList"
                                           [value]="year.numYearCode">{{year.numYear}}</option>
                                     </select>
                                     <span
                                        *ngIf="txtSaudiHeld.invalid && (txtSaudiHeld.dirty || isDriverSubmitted || txtSaudiHeld.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtSaudiHeld.errors?.CustomNumberDirective">
                                           {{ 'No Of Years Saudi Licence Held is required'| translate}}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Profession'| translate }}</label>
                                     <select id="txtProfession" name="txtProfession" class="form-control"
                                        selectRequired #txtProfession="ngModel"
                                        [(ngModel)]="diverObj.DriverProfession">
                                        <option [value]="0">{{'Select Profession'| translate }}</option>
                                        <option *ngFor="let profObj of bindObj.profList"
                                           [value]="profObj.Professioncode">
                                           {{Lng=="en"?profObj.ProfessionDesc_Eng:profObj.ProfessionDesc_Ar}}
                                        </option>
                                     </select>
                                     <span
                                        *ngIf="txtProfession.invalid && (txtProfession.dirty || isDriverSubmitted || txtProfession.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtProfession.errors?.selectRequired">
                                           {{ 'Profession is required'| translate}}
                                        </div>
                                     </span>
                                  </div>
                
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{ 'Children Under 16 years'| translate}}</label>
                                     <select class="form-control" name="txtChildYears" id="txtChildYears"
                                        selectRequired #txtChildYears="ngModel"
                                        [(ngModel)]="diverObj.DriverChildrenYears">
                                        <option [value]="0">
                                           {{ 'Select Children Under 16 Years' | translate }}</option>
                                        <option *ngFor="let under16 of bindObj.ChildrenUnder16List"
                                           [value]="under16.CODE">
                                           {{Lng=="en"?under16.CHILDREN_COUNT_EN:under16.CHILDREN_COUNT_AR}}
                                        </option>
                                     </select>
                                     <span
                                        *ngIf="txtChildYears.invalid && (txtChildYears.dirty || isDriverSubmitted || txtChildYears.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtChildYears.errors?.selectRequired">
                                           {{ 'Children Under 16 years is required'|translate}}</div>
                                     </span>
                                  </div>
                               </div>
                            </div>
                            <div class="Field">
                               <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label
                                        class="lbltext">{{'Other Countries Licence Held'| translate }}</label>
                                     <select id="txtOtherSaudiHeld" name="txtOtherSaudiHeld"
                                        class="form-control" #txtOtherSaudiHeld="ngModel" selectRequired
                                        [(ngModel)]="diverObj.OtherCountriesLicenceHeld">
                                        <option [value]="0">{{'Select Countries Licence Held'| translate }}
                                        </option>
                                        <option *ngFor="let nat of bindObj.NationalityMasterList"
                                           [value]="nat.NationalityDesc">
                                           {{Lng=="en"? nat.NationalityDescEn :nat.NationalityDescAr }}
                                        </option>
                                     </select>
                                     <span
                                        *ngIf="txtOtherSaudiHeld.invalid && (txtOtherSaudiHeld.dirty || isDriverSubmitted || txtOtherSaudiHeld.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtOtherSaudiHeld.errors?.selectRequired">
                                           {{ 'Other Countries Licence Held is required'| translate}}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label
                                        class="lbltext">{{'No of Years License Held for Each Country'| translate }}</label>
                                     <select name="txtdrivingLicHeld" id="txtdrivingLicHeld"
                                        class="form-control" selectRequired
                                        [(ngModel)]="diverObj.NumberOfYearsEachCountry"
                                        #txtdrivingLicHeld="ngModel">
                                        <option [value]="0">
                                           {{'Select each country license held'| translate }}</option>
                                        <option *ngFor="let year of bindObj.LicenceForEachCountryList"
                                           [value]="year.CODE">
                                           {{Lng=="en"?year.DRIVING_LICENSE_YEARS_EN: year.DRIVING_LICENSE_YEARS_AR }}
                                        </option>
                                     </select>
                                     <span
                                        *ngIf="txtdrivingLicHeld.invalid && (txtdrivingLicHeld.dirty || isDriverSubmitted|| txtdrivingLicHeld.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtdrivingLicHeld.errors?.selectRequired">
                                           {{ 'No of Years License Held for Each Country is required'|translate}}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label
                                        class="lbltext">{{'Medical Conditions  as Stated in the driving licence '| translate }}</label>
                                     <select name="txtdrivingMedConditions" id="txtdrivingMedConditions"
                                        class="form-control" selectRequired
                                        [(ngModel)]="diverObj.DriverMedicalConditions"
                                        #txtdrivingMedConditions="ngModel">
                                        <option [value]="0">{{'Select Medical Condition' | translate}}
                                        </option>
                                        <option *ngFor="let medObj of bindObj.restrainList"
                                           [value]="medObj.restraintID">
                                           {{ Lng=="en"?medObj.restraintDescEn:medObj.restraintDescAr }}
                                        </option>
                                     </select>
                                     <span
                                        *ngIf="txtdrivingMedConditions.invalid && (txtdrivingMedConditions.dirty || isDriverSubmitted || txtdrivingMedConditions.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtdrivingMedConditions.errors?.selectRequired">
                                           {{ 'Medical Conditions  as Stated in the driving licence is required'| translate}}
                                        </div>
                                     </span>
                                  </div>
                               </div>
                               <div class="row">

                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'RelationWithInsured'| translate }}</label>
                                     <select id="txtDriverRelation" selectRequired name="txtDriverRelation"
                                        class="form-control" [(ngModel)]="diverObj.RelationWithInsured"
                                        #txtDriverRelation="ngModel">
                                        <option [value]="0">{{'Select Relation With Insured'| translate }}
                                        </option>
                                        <option *ngFor="let relObj of bindObj.relationList"
                                           [value]="relObj.RelationId">
                                           {{ Lng=="en"? relObj.RelationNameEn:relObj.RelationNameAr }}
                                        </option>
                                     </select>
                                     <span
                                        *ngIf="txtDriverRelation.invalid && (txtDriverRelation.dirty || isDriverSubmitted || txtDriverRelation.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtDriverRelation.errors?.selectRequired">
                                           {{'Relation with Insured is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Road Convictions'| translate}}</label>
                                     <div class="roadconvictions">
                                        <select
                                           style="width:auto;border-right: none;border-left: none;border-top: none;"
                                           class="form-control" name="txtRoadConvictions"
                                           id="txtRoadConvictions" selectRequired
                                           [(ngModel)]="diverObj.RoadConvictions"
                                           #txtRoadConvictions="ngModel">
                                           <option [value]="0">{{'Select Road Convictions' | translate}}
                                           </option>
                                           <option *ngFor="let road of bindObj.RoadConvictionList"
                                              [value]="road.RoadConviction_ID">
                                              {{Lng=="en"?road.RoadConviction_Eng:road.RoadConviction_Ar}}
                                           </option>
                                        </select>
                                     </div>
                                     <span
                                        *ngIf="txtRoadConvictions.invalid && (txtRoadConvictions.dirty || isDriverSubmitted || txtRoadConvictions.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtRoadConvictions.errors?.selectRequired">
                                           {{'Road Convictions is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Driver Usage Percent'| translate }}</label>
                                     <input type="text" class="form-control" required numbersOnly
                                        minlength="1" maxlength="3" id="txtDriverUsagePercentage"
                                        name="txtDriverUsagePercentage"
                                        [(ngModel)]="diverObj.DriverUsagePercentage"
                                        #txtDriverUsagePercentage="ngModel" autocomplete="off" />
                                     <span
                                        *ngIf="txtDriverUsagePercentage.invalid && (txtDriverUsagePercentage.dirty || isDriverSubmitted || txtDriverUsagePercentage.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtDriverUsagePercentage.errors?.required">
                                           {{'Driver Usage Percentage is required'| translate }}
                                        </div>
                                        <div *ngIf="txtDriverUsagePercentage.errors?.minlength">
                                           {{'Driver Usage Percentage must be 1 digits'| translate }}
                                        </div>
                                        <div *ngIf="txtDriverUsagePercentage.errors?.maxlength">
                                           {{'Driver Usage Percentage must be 4 digits'| translate }}
                                        </div>
                                     </span>
                                  </div>
                               </div>
                               <div class="row" style="margin-top: 15px;margin-left: 1px;">
                                  <h5 class="addresslabel">{{'Residence Address' | translate}}</h5>
                               </div>
                               <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Residence Additional No'| translate }}</label>
                                     <input type="text" class="form-control" required numbersOnly
                                        minlength="4" maxlength="4" id="txtResAdditionalNo"
                                        name="txtResAdditionalNo"
                                        [(ngModel)]="diverObj.ResidenceAdditionalNumber"
                                        #txtResidenceAdditionalNumber="ngModel" autocomplete="off" />
                                     <span
                                        *ngIf="txtResidenceAdditionalNumber.invalid && (txtResidenceAdditionalNumber.dirty || isDriverSubmitted || txtResidenceAdditionalNumber.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtResidenceAdditionalNumber.errors?.required">
                                           {{'Residence Additional No is required'| translate }}
                                        </div>
                                        <div *ngIf="txtResidenceAdditionalNumber.errors?.minlength">
                                           {{'Residence Additional No must be 4 digits'| translate }}
                                        </div>
                                        <div *ngIf="txtResidenceAdditionalNumber.errors?.maxlength">
                                           {{'Residence Additional No must be 4 digits'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Residence Building No'| translate }}</label>
                                     <input type="text" class="form-control" required numbersOnly
                                        minlength="4" maxlength="4" id="txtResBuildingNo"
                                        name="txtResBuildingNo"
                                        [(ngModel)]="diverObj.ResidenceBuildingNumber"
                                        #txtResidenceBuildingNumber="ngModel" autocomplete="off" />
                                     <span
                                        *ngIf="txtResidenceBuildingNumber.invalid && (txtResidenceBuildingNumber.dirty || isDriverSubmitted || txtResidenceBuildingNumber.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtResidenceBuildingNumber.errors?.required">
                                           {{'Residence Building No is required'| translate }}
                                        </div>
                                        <div *ngIf="txtResidenceBuildingNumber.errors?.minlength">
                                           {{'Residence Building No must be 4 digits'| translate }}
                                        </div>
                                        <div *ngIf="txtResidenceBuildingNumber.errors?.maxlength">
                                           {{'Residence Building No must be 4 digits'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Residence City'| translate }}</label>
                                     <select id="txtResCity" name="txtResCity" selectRequired
                                        class="form-control" [(ngModel)]="diverObj.DriverCity"
                                        #txtResCity="ngModel" (change)="ResCityChange(diverObj.DriverCity)">
                                        <option [value]="0">{{'Select Driver City'| translate }}</option>
                                        <option *ngFor="let cty of bindObj.CityMasterList"
                                           [value]="cty.CITYNAME">
                                           {{ Lng=="en"? cty.CITYNAMEEn:cty.CITYNAMEAr }}</option>
                                     </select>
                                     <span
                                        *ngIf="txtResCity.invalid && (txtResCity.dirty || isDriverSubmitted || txtResCity.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtResCity.errors?.selectRequired">
                                           {{'Residence City is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Residence District'| translate }}</label>
                                     <input type="text" class="form-control" required id="txtResDistrict"
                                        name="txtResDistrict" [(ngModel)]="diverObj.ResidenceDistrict"
                                        #txtResDistrict="ngModel" />
                                     <span
                                        *ngIf="txtResDistrict.invalid && (txtResDistrict.dirty || isDriverSubmitted || txtResDistrict.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtResDistrict.errors?.required">
                                           {{'Residence District is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Residence Street'| translate }}</label>
                                     <input type="text" class="form-control" required id="txtResStreet"
                                        name="txtResStreet" [(ngModel)]="diverObj.ResidenceStreet"
                                        #txtResStreet="ngModel" />
                                     <span
                                        *ngIf="txtResStreet.invalid && (txtResStreet.dirty || isDriverSubmitted || txtResStreet.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtResStreet.errors?.required">
                                           {{'Residence Street is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Residence Unit No'| translate }}</label>
                                     <input type="text" class="form-control" required numbersOnly
                                        minlength="1" maxlength="4" id="txtResUnitNo" name="txtResUnitNo"
                                        [(ngModel)]="diverObj.ResidenceUnitNumber" #txtResUnitNo="ngModel" />
                                     <span
                                        *ngIf="txtResUnitNo.invalid && (txtResUnitNo.dirty || isDriverSubmitted || txtResUnitNo.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtResUnitNo.errors?.required">
                                           {{'Residence Unit No is required'| translate }}</div>
                                        <div *ngIf="txtResUnitNo.errors?.minlength">
                                           {{'Residence Unit No must be ateleast 1 digit'| translate }}</div>
                                        <div *ngIf="txtResUnitNo.errors?.maxlength">
                                           {{'Residence Unit No must be ateleast 1 digit'| translate }}</div>
                                     </span>
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Residence Zip Code'| translate }}</label>
                                     <input type="text" class="form-control" required id="txtResZipCode"
                                        name="txtResZipCode" minlength="5" maxlength="5"
                                        [(ngModel)]="diverObj.ResidenceZipCode"
                                        #txtResidenceZipCode="ngModel" numbersOnly />
                                     <span
                                        *ngIf="txtResidenceZipCode.invalid && (txtResidenceZipCode.dirty || isDriverSubmitted || txtResidenceZipCode.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtResidenceZipCode.errors?.required">
                                           {{'Residence Zip Code is required'| translate }}
                                        </div>
                                        <div *ngIf="txtResidenceZipCode.errors?.minlength">
                                           {{'Residence Zip Code must be 5 digits'| translate }}
                                        </div>
                                        <div *ngIf="txtResidenceZipCode.errors?.maxlength">
                                           {{'Residence Zip Code must be 5 digits'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Residence Zone'| translate }}</label>
                                     <input type="text" class="form-control" required id="txtResZone"
                                        name="txtResZone" [(ngModel)]="diverObj.ResidenceZone"
                                        #txtResidenceZone="ngModel" [disabled]="true" />
                                     <span
                                        *ngIf="txtResidenceZone.invalid && (txtResidenceZone.dirty || isDriverSubmitted || txtResidenceZone.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtResidenceZone.errors?.required">
                                           {{'Residence Zone is required'| translate }}</div>
                                     </span>
                                  </div>
                               </div>
                               <div class="row" style="margin-top: 15px;margin-left: 1px;">
                                  <h5 class="addresslabel">{{'Office Address' | translate}}</h5>
                               </div>
                               <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Office Additional Code'| translate }}</label>
                                     <input type="text" class="form-control" minlength="4" maxlength="4"
                                        numbersOnly id="txtOffcAdditionalNo" name="txtOffcAdditionalNo"
                                        [(ngModel)]="diverObj.OfficeAdditionalNumber"
                                        #txtOffcAdditionalNo="ngModel" autocomplete="off" />
                                     <span
                                        *ngIf="txtOffcAdditionalNo.invalid && (txtOffcAdditionalNo.dirty || isDriverSubmitted || txtOffcAdditionalNo.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtOffcAdditionalNo.errors?.required">
                                           {{'AdditionalNumber is required'| translate }}
                                        </div>
                                        <div *ngIf="txtOffcAdditionalNo.errors?.minlength">
                                           {{'AdditionalNumber must be 4 digits'| translate }}
                                        </div>
                                        <div *ngIf="txtOffcAdditionalNo.errors?.maxlength">
                                           {{'AdditionalNumber must be 4 digitss'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Office Building No'| translate }}</label>
                                     <input type="text" class="form-control" minlength="4" maxlength="4"
                                        numbersOnly id="txtOffcBuildingNo" name="txtOffcBuildingNo"
                                        [(ngModel)]="diverObj.OfficeBuildingNumber"
                                        #txtOffcBuildingNo="ngModel" autocomplete="off" />
                                     <span
                                        *ngIf="txtOffcBuildingNo.invalid && (txtOffcBuildingNo.dirty || isDriverSubmitted || txtOffcBuildingNo.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtOffcBuildingNo.errors?.required">
                                           {{'BuildingNumber is required'| translate }}
                                        </div>
                                        <div *ngIf="txtOffcBuildingNo.errors?.minlength">
                                           {{'BuildingNumber must be 4 digits'| translate }}
                                        </div>
                                        <div *ngIf="txtOffcBuildingNo.errors?.maxlength">
                                           {{'BuildingNumber must be 4 digits'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Office City'| translate }}</label>
                                     <select id="txtOffcCityID" name="txtOffcCityID" class="form-control"
                                        [(ngModel)]="diverObj.OfficeCity" #txtOffcCityID="ngModel"
                                        (change)="OfficeCityChange(diverObj.OfficeCity)">
                                        <option [value]="0">{{'Select Office City'| translate }}</option>
                                        <option *ngFor="let cty of bindObj.CityMasterList"
                                           [value]="cty.CITYNAME">
                                           {{ Lng=="en"? cty.CITYNAMEEn:cty.CITYNAMEAr }}</option>
                                     </select>
                                     <span
                                        *ngIf="txtOffcCityID.invalid && (txtOffcCityID.dirty || isDriverSubmitted || txtOffcCityID.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtOffcCityID.errors?.selectRequired">
                                           {{'City is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Office Disrtict Name'| translate }}</label>
                                     <input type="text" class="form-control" id="txtOffcDistrict"
                                        name="txtOffcDistrict" [(ngModel)]="diverObj.OfficeDistrict"
                                        #txtOffcDistrict="ngModel" />
                                     <span
                                        *ngIf="txtOffcDistrict.invalid && (txtOffcDistrict.dirty || isDriverSubmitted || txtOffcDistrict.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtOffcDistrict.errors?.required">
                                           {{'Disrtict Name is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Office Street Name'| translate }}</label>
                                     <input type="text" class="form-control" id="txtResStreet"
                                        name="txtOffcStreet" [(ngModel)]="diverObj.OfficeStreet"
                                        #txtOffcStreet="ngModel" />
                                     <span
                                        *ngIf="txtOffcStreet.invalid && (txtOffcStreet.dirty || isDriverSubmitted || txtOffcStreet.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtOffcStreet.errors?.required">
                                           {{'Street Name is required'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Office Unit No'| translate }}</label>
                                     <input type="text" class="form-control" minlength="1" maxlength="4"
                                        numbersOnly id="txtOffcUnitNo" name="txtOffcUnitNo"
                                        [(ngModel)]="diverObj.OfficeUnitNumber" #txtOffcUnitNo="ngModel" />
                                     <span
                                        *ngIf="txtOffcUnitNo.invalid && (txtOffcUnitNo.dirty || isDriverSubmitted || txtOffcUnitNo.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtOffcUnitNo.errors?.required">
                                           {{'Office Unit No is required'| translate }}</div>
                                        <div *ngIf="txtOffcUnitNo.errors?.minlength">
                                           {{'Office Unit No must be ateleast 1 digit'| translate }}</div>
                                        <div *ngIf="txtOffcUnitNo.errors?.maxlength">
                                           {{'Office Unit No must be ateleast 1 digit'| translate }}</div>
                                     </span>
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Office Postal Code'| translate }}</label>
                                     <input type="text" class="form-control" numbersOnly minlength="5"
                                        maxlength="5" id="txtOffcZipCode" name="txtOffcZipCode"
                                        [(ngModel)]="diverObj.OfficeZipCode" #txtOffcZipCode="ngModel" />
                                     <span
                                        *ngIf="txtOffcZipCode.invalid && (txtOffcZipCode.dirty || isDriverSubmitted || txtOffcZipCode.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtOffcZipCode.errors?.required">
                                           {{'PostalCode must not start with zero'| translate }}
                                        </div>
                                        <div *ngIf="txtOffcZipCode.errors?.minlength">
                                           {{'PostalCode must be 5 digits'| translate }}
                                        </div>
                                        <div *ngIf="txtOffcZipCode.errors?.maxlength">
                                           {{'PostalCode must be 5 digits'| translate }}
                                        </div>
                                     </span>
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                     <label class="lbltext">{{'Office Zone'| translate }}</label>
                                     <input type="text" class="form-control" id="txtOffcZone"
                                        name="txtOffcZone" [(ngModel)]="diverObj.OfficeZone"
                                        #txtOffcZone="ngModel" [disabled]="true" />
                                     <span
                                        *ngIf="txtOffcZone.invalid && (txtOffcZone.dirty || isDriverSubmitted || txtOffcZone.touched)"
                                        class="text-danger valid">
                                        <div *ngIf="txtOffcZone.errors?.required">
                                           {{'Office Zone is required'| translate }}</div>
                                     </span>
                                  </div>
                               </div>
                               <div class="row">
                                  <button class="btn btns btn-primary" id="btnAddDriver" name="btnAddDriver"
                                     (click)="AddNewDriver(driverfrm.valid)"
                                     [disabled]="this.objmdlDriverInfoRes.Status.StatusCode=='F' || !ds.valid"
                                     style="margin-top:20px!important;float:left;">{{'Add Driver'| translate }}</button>
                               </div>
                            </div>
                            <div class="Field">
                               <div class="row">
                               </div>
                            </div>
                         </form>
                      </div>
                   </div>
    
                </div>
             </div>
          </div>
       </div>
    </div>
 </div> -->
    <!-- Add Driver End -->

</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/CompRenewalPolicy/CompRenewalPolicy.html